import { render, staticRenderFns } from "./Index_new.vue?vue&type=template&id=2d149b2c&scoped=true&"
import script from "./Index_new.vue?vue&type=script&lang=js&"
export * from "./Index_new.vue?vue&type=script&lang=js&"
import style0 from "./Index_new.vue?vue&type=style&index=0&id=2d149b2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d149b2c",
  null
  
)

export default component.exports